import React, { useState, useEffect } from "react"
import { graphql, Link } from "gatsby"
import { Container, Row, Col, Button } from "react-bootstrap"
import Layout from "@layouts/Layout"
import BackgroundImage from "gatsby-background-image"
import { GiDandelionFlower } from "react-icons/gi"
import { BsArrowRight } from "react-icons/bs"
import { useQueryParam, StringParam } from "use-query-params"
import SEO from "../components/SEO"

const Products = ({ data }) => {
  const [category] = useQueryParam("cat", StringParam)
  const [filteredProducts, setFilteredProducts] = useState(null)
  const {
    allContentfulProduct: { products },
  } = data

  useEffect(() => {
    if (!category) return setFilteredProducts(products)

    const filtered = products.filter(product => {
      return product.category === category
    })

    setFilteredProducts(filtered)
  }, [category, products])

  function titleCase(string) {
    return string
      ? string.charAt(0).toUpperCase() + string.slice(1) + "s"
      : "Products"
  }

  return (
    <Layout>
      <SEO title={`${titleCase(category)}`} />
      <section className="py-6 text-center bubble-pattern">
        <Container>
          <Row>
            <Col>
              <h1 className="text-capitalize">
                <u>{category ? category + "s" : "All products"}</u>
              </h1>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pb-6 pb-md-8 pt-3">
        <Container>
          <Row>
            {filteredProducts &&
              filteredProducts.map((product, index) => {
                return (
                  <Col lg={4} key={index} className="mt-5 mt-md-6">
                    <BackgroundImage
                      fluid={product.image.fluid}
                      alt={product.title}
                    >
                      <h1
                        className="dancing py-9 text-center text-white display-3 mb-3"
                        style={{ opacity: "0.8" }}
                      ></h1>
                    </BackgroundImage>

                    <h2>
                      <u>{product.title}</u>
                    </h2>

                    <p className="line-clamp mb-4">
                      {product.description.description}
                    </p>

                    <Button
                      as={Link}
                      to={`/product/${product.slug}`}
                      variant="powder"
                    >
                      Find out more <BsArrowRight size="1.5em" />
                    </Button>
                  </Col>
                )
              })}
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

export const query = graphql`
  {
    allContentfulProduct(sort: { order: ASC, fields: [order] }) {
      products: nodes {
        id
        price
        slug
        title
        description {
          description
        }
        image {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
        category
      }
    }
  }
`

export default Products
